import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 45 45',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icon" transform="translate(-134 -617)">
      <g
        fill="none"
        id="Elipse_251"
        data-name="Elipse 251"
        transform="translate(134 617)"
        stroke="#5a005a"
        strokeWidth="2"
      >
        <circle cx="22.5" cy="22.5" r="22.5" stroke="none" />
        <circle cx="22.5" cy="22.5" r="21.5" fill="none" />
      </g>
      <path
        fill={fill}
        id="plane-arrival-solid"
        d="M26.574,19.078H.681A.681.681,0,0,0,0,19.76v1.363a.681.681,0,0,0,.681.681H26.574a.681.681,0,0,0,.681-.681V19.76A.681.681,0,0,0,26.574,19.078ZM1.908,8.758l3.779,3.407a2.666,2.666,0,0,0,1.085.593L19.02,16.095a6.512,6.512,0,0,0,3.45.058c1.264-.352,1.85-.9,2.012-1.521s-.074-1.393-1-2.341a6.585,6.585,0,0,0-3.016-1.7L16.318,9.457l-4.274-8.17a.708.708,0,0,0-.5-.507L8.775.024a.7.7,0,0,0-.882.7L9.934,7.717,5.581,6.532,4.407,3.641a.7.7,0,0,0-.469-.423L2.245,2.757a.7.7,0,0,0-.882.676l.01,4.335A1.469,1.469,0,0,0,1.908,8.758Z"
        transform="translate(143.5 628.197)"
      />
    </g>
  </svg>
);

export default SVG;
